import React, { useMemo } from 'react'
import useOffers from 'hooks/Offers/useOffers'
import { useAppSelector } from 'hooks/reduxHooks'
import HighIntentOffersCarousel from 'components/OfferList/HighIntent/HighIntentOffersCarousel'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { timeNowInSecond } from 'lib/datetime/time'

interface Props {
  similarTourIds: Array<string>
  onClick?: () => void
}

function TourV2SimilarTourCarousel(props: Props) {
  const { similarTourIds, onClick } = props

  const offerIds = useMemo(() =>
    similarTourIds.map((id) => `tour-${id}`),
  [similarTourIds]
  )

  const [offers, loading] = useOffers(offerIds)

  const offersLoading = useAppSelector(state => state.offer.offersLoading)
  const individualOffersStillLoading = useMemo(() => {
    return offerIds.some(offerId => offersLoading[offerId])
  }, [offerIds, offersLoading])

  const highIntentOffers = useMemo((): Array<App.HighIntentOffer> => {
    return offers
      .filter((offer): offer is App.Tours.TourV2OfferSummary => {
        // Ensure we have a complete tour offer with required properties
        return offer.parentType === 'tour_v2' &&
          offer.variations &&
          Object.keys(offer.variations).length > 0 &&
          offer.variations[Object.keys(offer.variations)[0]]?.images?.length > 0
      })
      .map((offer) => ({
        offerId: offer.id,
        offerType: offer.type,
        creationTime: timeNowInSecond(),
        category: 'recently_viewed' as App.RecentlyViewedType,
        score: 1,
      }))
  }, [offers])

  if (loading || individualOffersStillLoading || offers.length === 0 || highIntentOffers.length === 0) {
    return null
  }

  return (
    <LayoutContainer>
      <VerticalSpacer gap={64}>
        <HighIntentOffersCarousel
          highIntentOffers={highIntentOffers}
          analyticsLabel="Similar Tours"
          onClick={onClick}
        />
      </VerticalSpacer>
    </LayoutContainer>
  )
}

export default React.memo(TourV2SimilarTourCarousel)
